<button
  extended
  mat-flat-button
  routerLinkActive="router-link-active"
  [color]="_color"
  [ngClass]="{
    'n-one-btn': _hasBorder,
    'n-one-selected': _selected,
  }"
  [routerLink]="[_dynamicRoute]"
>
  <mat-icon
    class="material-icons"
    [ngClass]="{
      'n-one-btn-icon-colorful': _colorfulIcon,
    }"
    >{{ _icon }}</mat-icon
  >
  {{ _label }}
</button>
